import { createFileRoute } from '@tanstack/react-router'
import { CountersPage } from '@/pages/counters/CountersPage'

export const Route = createFileRoute('/_private/counters/')({
    component: CountersPage,
})
